import { ITaxes } from './iTaxes';

export interface ITaxUserData {
    country: string,
    paymentMethod: string
}

export class TaxesCalculator implements ITaxes {
    private vatService: ITaxes;
    private feeService: ITaxes;
    private userData: ITaxUserData

    constructor(feeService: ITaxes, vatService: ITaxes, taxUserData: ITaxUserData) {
        this.feeService = feeService;
        this.vatService = vatService;
        this.userData = taxUserData;
    }

    public async calculate(revenue: number): Promise<number> {
        const vat = await this.vatService.calculate(revenue, this.userData.country);
        const fee = await this.feeService.calculate(revenue, this.userData.paymentMethod, vat);
        const clearRevenue = revenue - fee - vat;
        console.log('Calculating clear revenue', {
            clear: clearRevenue,
            fee: fee,
            grows: revenue,
            vat: vat
        });
        return clearRevenue;
    }
}
